// import { $callapi } from '../../common/request.js'
const nullUser = {
  id: 0, // ID为0表示未登录
  name: "未登录",
  icon: null,
  money: 0,
  score: 0,
  phone: "",
  email: "",
  address: {},
  is_signed: false, // 是否已签到
  message: {
    // 消息
    total: 0, // 总消息
    system: 0, // 系统消息
    social: 0, // 互动消息
  },
  coupon: 0, //优惠券
  keyvals: {},
  shopcart_count: 0,
  favorite_count: 0,
  code: "",
  ichat: {
    count: 0,
  },

  merchant: null, // 所属商家
  qrcode: "", //用户二维码路径

  lang: "", //语言
  currency: "", // 币种
  user_lock_address: 0,
  is_hyb_sup:false

}
const user = {
  state: {
    user: Object.assign({}, nullUser),
    city: "昆明市", // 用户所在城市
  },
  mutations: {
    SET_USER(state, user) {
      Object.assign(state.user, user || nullUser)
    },
    SET_CITY(state, city) {
      state.city = city
    },
    SET_MESSAGECOUNT(state, count) {
      state.user.message.total = count
    },
    SUB_MESSAGECOUNT(state) {
      const c = state.user.message_count - 1
      state.user.message_count = c >= 0 ? c : 0
    },
    SUB_FAVORITE_COUNT(state) {
      if (state.user.social) state.user.social.favorite = Math.max(state.user.social.favorite - 1, 0)
    },
    ADD_FAVORITE_COUNT(state) {
      if (state.user.social) state.user.social.favorite = state.user.social.favorite + 1
    },
    SET_ADDRESS(state, id) {
      state.user.user_lock_address = id
    },
    SET_LOCKADDRESS(state, address) {
      state.user.address= address
    }
  },
  actions: {
    // setUser({commit, state}, user){
    // 	commit("SET_USER", user)
    // },
  },
}

export default user
